  
export default function getIllumination(phase) {
    // Calculate percentage of moon illuminated
    const illumination = phase <= 0.5
      ? phase * 2 
      : 2 - (phase * 2);
    return (illumination * 100).toFixed(1);
  };


